module.exports = {
    'Init': require('./init'),
    'TypeAhead': require('./typeAhead'),
    'Search': require('./search'),
};